// External Imports
import { useState } from "react";

// Internal Imports
import { requestAdminAPI } from "../../api/posh-api";
import Heading from "../UI/Heading";
import DetailPair from "../UI/DetailPair";
import SelectPair from "../UI/SelectPair";
import Modal from "../UI/Modal";
import { MdClose } from "react-icons/md";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";
import CustomerSelector from "../customers-page/CustomerSelector";

/** ========================================================================
 * * Add Coupon Page
 * Renders a page, which allows adding a new coupon to the database.
 * ========================================================================== */

export default function AddCoupon({ open, setOpen, onComplete }) {

  // Initialize States
  const [loading, setLoading] = useState(false);
  const [customer, setCustomer] = useState();

  /* ======================= ADD COUPON ======================= */
  const addCouponHandler = async () => {
    try {
      setLoading(true);
      const payload = {
        id: document.getElementById("code").value,
        type: document.getElementById("type").value,
        amount: parseFloat(document.getElementById("amount").value),
        reusable: document.getElementById("reusable").value === "Yes",
        customerId: customer?.id,
      };
      await requestAdminAPI("add-coupon", payload);
      onComplete && onComplete();
      setOpen(false);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="modal gap-4 lg:w-[45vw]">
        <Heading
          title="Add Coupon"
          text="Coupons can be used by anyone unless a customer is specified. 
        If you do not want the coupon to be used again, uncheck reusable."
          isBackArrow={false}
        >
          <MdClose className="icon" onClick={() => setOpen(false)} />
        </Heading>

        <div className="info lg:grid-cols-3">
          <DetailPair
            label="Coupon Code"
            edit={true}
            inputOptions={{
              type: "text",
              id: "code",
              placeholder: "Enter Coupon Code",
            }}
          />
          <SelectPair
            options={["percentage", "fixed"]}
            label="Type"
            edit={true}
            inputOptions={{
              id: "type",
              placeholder: "Select Type",
              required: true,
            }}
          />
          <DetailPair
            label="Amount"
            edit={true}
            inputOptions={{
              type: "number",
              step: "0.01",
              id: "amount",
              placeholder: "e.g. 0.625 for percentage or 5.00 for fixed",
              required: true,
            }}
          />

          <SelectPair
            options={["No", "Yes"]}
            label="Reusable"
            edit={true}
            inputOptions={{
              id: "reusable",
            }}
          />
          <div className="lg:col-span-2">
            <CustomerSelector selected={customer?.id} onSelect={setCustomer} />
          </div>
        </div>
        {loading ? (
          <LoadingSpinnerWrapper />
        ) : (
          <div className="flex items-center mt-4 space-x-4 text-sm">
            <div className="w-full btn-secondary">Cancel</div>
            <div onClick={addCouponHandler} className="w-full btn-primary">
              Confirm
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}
